<template>
  <div>
    <!--el-row type="flex" justify="end">
      <el-col :span="24" class="right">
        <el-radio-group v-model="order">
          <el-radio class="small" label="price">Melhor preço</el-radio>
          <el-radio class="small" label="deadline">Melhor prazo</el-radio>
        </el-radio-group>
      </el-col>
    </el-row-->
    <div v-if="tableData && tableData.length > 0">
      <CalculateResultItem :header="true" />
      <CalculateResultItem
        :header="false"
        v-for="itemData of tableData"
        :key="itemData.id"
        :modality="itemData.name"
        :deadline="itemData.deadline"
        :logo="itemData.image"
        :price="itemData.value"
        :cash="0"
        :savings="0"
        :data="itemData"
        label="Criar"
        @redirect="redirect"
      />
    </div>
    <div v-else-if="tableList && tableList.length > 0">
      <el-collapse accordion>
        <el-collapse-item :name="headerData.line" v-for="headerData of tableList" :key="headerData.line">
          <template slot="title">
            LINHA {{ headerData.line }}&nbsp;<el-tag style="margin-left: 100px"
              >De: {{ headerData.data.sourceZipcode }} para {{ headerData.data.destinyZipcode }}</el-tag
            >&nbsp;<el-tag type="success">Peso: {{ headerData.data.weight }}</el-tag>
          </template>

          <el-alert v-if="headerData.price && !Array.isArray(headerData.price) && headerData.price.error">{{
            headerData.price.message
          }}</el-alert>

          <div v-else>
            <CalculateResultItem :header="true" />
            <CalculateResultItem
              :header="false"
              v-for="itemData of headerData.price"
              :key="itemData.id"
              :modality="itemData.name"
              :deadline="itemData.deadline"
              :logo="itemData.image"
              :price="itemData.value"
              :cash="0"
              :savings="0"
              :data="itemData"
              label="Postar"
              :line="headerData.line"
              @redirect="redirect"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else>
      <el-alert
        title="Nenhum serviço encontrado para esta cotação."
        description="Possíveis motivos: valor declarado acima do limite permitido, peso fora da faixa ou nenhuma transportadora habilitada."
        type="warning"
        show-icon
        :closable="false"
      />
    </div>
  </div>
</template>

<script>
import CalculateResultItem from "./CalculateResultItem.vue";

export default {
  name: "CalculateResultList",
  data() {
    return {
      tableData: [],
      tableList: [],
      order: "price",
    };
  },
  methods: {
    redirect(line) {
      if (line) {
        const itemData = this.tableList.find((x) => x.line === line);
        localStorage.setItem("QUOTATION_FORM", JSON.stringify(itemData.data));
      }
      const route = this.$router.resolve({ name: "post.page.add" });
      window.open(route.href, "_blank");
      //this.$router.push({ name: 'post.page.add' });
    },
  },
  components: { CalculateResultItem },
  mounted() {
    const tableList = JSON.parse(localStorage.getItem("QUOTATION_LIST"));
    const tableData = JSON.parse(localStorage.getItem("QUOTATION"));
    console.log("tableList", tableList, tableData);
    //localStorage.removeItem("QUOTATION");
    this.tableData = tableData;
    this.tableList = tableList;
    console.log("tableList", this.tableData, this.tableList);
  },
};
</script>

<style>
.right {
  text-align: right;
}
.small .el-radio__label {
  font-size: 12px !important;
}
</style>
